let env = null;

const Env = {
  initialize(envData) {
    env = envData
  },

  getEnv() {
    return env
  },

  getArkId() {
    return env.ark_id
  },

  getDefaultExternalUrlForGar() {
    return env.default_external_url_for_gar
  },
};

export default Env;
